var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.$userInfo.isSupportUser
      ? _c("div", { staticClass: "tile is-parent pl-1" }, [
          _c("div", { staticClass: "tile is-child box" }, [
            _c("section", { staticClass: "container" }, [
              _c("label", { staticClass: "label" }, [
                _vm._v("Enable Assessment History"),
              ]),
              _c("div", { staticClass: "control" }, [
                _c("div", { staticClass: "pretty p-switch p-fill" }, [
                  _c("input", {
                    attrs: { type: "checkbox" },
                    domProps: { checked: _vm.companySetting.assessmentEnabled },
                    on: { change: _vm.assessmentHistoryChange },
                  }),
                  _c("div", { staticClass: "state p-primary" }, [
                    _c("label", [
                      _vm._v(
                        _vm._s(
                          _vm.companySetting.assessmentEnabled ? "Yes" : "No"
                        )
                      ),
                    ]),
                  ]),
                ]),
              ]),
              _c("div", { staticClass: "buttons is-right" }, [
                _c(
                  "div",
                  { staticClass: "is-flex is-justify-content-right pt-3" },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "button is-outlined",
                        class: `is-outlined-btn-${_vm.$theme.name}`,
                        on: { click: _vm.reset },
                      },
                      [_vm._v("Reset")]
                    ),
                  ]
                ),
                _c(
                  "div",
                  { staticClass: "is-flex is-justify-content-right pt-3" },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "button is-success is-outlined",
                        class: `is-outlined-btn-${_vm.$theme.name}`,
                        on: { click: _vm.save },
                      },
                      [_vm._v("Save")]
                    ),
                  ]
                ),
              ]),
            ]),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }